import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
var t = /*#__PURE__*/function () {
  function t() {
    var _t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    _classCallCheck(this, t);

    this._seed = _t;
  }

  _createClass(t, [{
    key: "seed",
    set: function set(e) {
      this._seed = null == e ? Math.random() * t._m : e;
    }
  }, {
    key: "getInt",
    value: function getInt() {
      return this._seed = (t._a * this._seed + t._c) % t._m, this._seed;
    }
  }, {
    key: "getFloat",
    value: function getFloat() {
      return this.getInt() / (t._m - 1);
    }
  }, {
    key: "getIntRange",
    value: function getIntRange(_t2, e) {
      return Math.round(this.getFloatRange(_t2, e));
    }
  }, {
    key: "getFloatRange",
    value: function getFloatRange(e, s) {
      var n = s - e;
      return e + this.getInt() / t._m * n;
    }
  }]);

  return t;
}();

t._m = 2147483647, t._a = 48271, t._c = 0;
export { t as default };